import React from 'react';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { UtpCardGridProps } from './utp-card-grid-types';

type StyledUtpCardGridProps = Pick<UtpCardGridProps, 'cardNumber'> &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const StyledUtpCardGrid = styled.div<StyledUtpCardGridProps>`
  display: grid;
  grid-gap: 24px;

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: ${({ cardNumber }: StyledUtpCardGridProps) => `repeat(${cardNumber}, 144px)`};
  }
`;

export const utpCardGridStylesMap: Record<number, string> = {
  2: css`
    @media (--from-tablet) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 160px;
    }
  `,
  3: css`
    @media (--only-largeDesktop) {
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 160px;

      & div {
        flex-direction: row;
      }

      & img {
        width: 152px;
        height: 130px;
      }
    }

  @media (--from-tablet) and (--to-largeDesktop) {      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 265px;

      & img {
        width: 168px;
        height: 144px;
      }
    }

    @media (--only-tablet) {
      & img {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  `,
  4: css`
    && {
      @media (--only-largeDesktop) {
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: 308px;
      }

    @media (--from-tablet) and (--to-largeDesktop) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 160px 160px;

      & div {
        flex-direction: row;
      }
    }

      @media (--only-desktop) {
        & div div:first-child {
          width: 302px;
        }

        & img {
          width: 152px;
          height: 130px;
        }
      }

      @media (--only-tablet) {
        & div div:first-child {
          width: 178px;
          padding-right: 14px;
        }

        & img {
          width: 140px;
          height: 120px;
        }
      }
    }
  `,
  5: css`
    && {
      @media (--only-largeDesktop) {
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: 308px;
      }

      @media (--only-desktop) {
        & > div:nth-child(1),
        & > div:nth-child(2) {
          & div:first-child {
            width: 302px;
          }

          & img {
            width: 152px;
            height: 130px;
          }
        }
      }

      @media (--only-tablet) {
        & > div:nth-child(1),
        & > div:nth-child(2) {
          & div:first-child {
            width: 178px;
            padding-right: 14px;
          }

          & img {
            width: 140px;
            height: 120px;
          }
        }
      }

    @media (--from-tablet) and (--to-largeDesktop) {        grid-template-columns: repeat(6, 1fr);
        grid-template-rows: 160px 264px;

        div {
          grid-column: auto / span 2;
        }

        div:nth-child(1),
        div:nth-child(2) {
          flex-direction: row;
          grid-column: auto / span 3;
        }
      }
    }
  `,
};
